import { CatalogCategoriesSection } from 'app/src/features/Catalog/components/CatalogCategoriesSection'
import { CatalogProductListSection } from 'app/src/features/Catalog/components/CatalogProductListSection'
import { InformativeBannerWithTimerSection } from 'app/src/features/Catalog/components/InformativeBannerWithTimerSection'
import { SuggestAPartnershipSection } from 'app/src/features/Catalog/components/SuggestAPartnershipSection'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { DynamicPageWidget } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import type { ReactElement } from 'react'

export function ComponentRenderer(sections?: pageconfigurationsApi.SectionItem[]): ReactElement {
  const context = useWebAppContext()
  const showFavourites = sections?.some((s) => s.sectionName === 'FavouritesBanner') ?? false

  return (
    <>
      {sections &&
        sections?.map((section) => {
          switch (section.sectionName) {
            case 'CatalogInformativeBannerSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <InformativeBannerWithTimerSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'FavouritesBanner':
              return null
            case 'CatalogCategoriesSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <CatalogCategoriesSection {...props} showFavourites={showFavourites} />}
                  sectionItem={section}
                />
              )
            case 'CatalogProductListSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <CatalogProductListSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'SuggestPartnershipSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <SuggestAPartnershipSection {...props} />}
                  sectionItem={section}
                />
              )
            default:
              if (section?.renderingMode !== 'native') {
                return <DynamicPageWidget key={section.sectionName} sectionItem={section} />
              } else {
                context.logger?.warn('Unknown Native Section', { section: section.sectionName })
                return <></>
              }
          }
        })}
    </>
  )
}
